<template>
    <ion-textarea
        :value="modelValue"
        :auto-grow="props.autoGrow"
        :autocapitalize="props.autocapitalize"
        :autofocus="props.autofocus"
        :clear-on-edit="props.clearOnEdit"
        :color="props.color"
        class="textarea-simple light-grey4-background purple-purple-color"
        :class="textareaClass"
        :cols="props.cols"
        :debounce="props.debounce"
        :disabled="props.disabled"
        :enterkeyhint="props.enterkeyhint"
        :inputmode="props.inputmode"
        :maxlenght="props.maxlength"
        :minlength="props.minlength"
        :mode="props.mode"
        :name="props.name"
        :placeholder="props.placeholder"
        :readonly="props.readonly"
        :required="props.required"
        :rows="props.rows"
        :spellcheck="props.spellcheck"
        :wrap="props.wrap"
        @ionInput="$emit('update:modelValue', $event.target.value); handleChange($event);"
        @ionBlur="handleBlur($event); emit('blur', $event)"
        @ionChange="emit('change', $event)"
        @ionFocus="emit('focus', $event)"
    />
    <div v-if="errors.length" class="coral-grey3-color fs-small pt-1 pl-1">
        {{ errors[0] }}
    </div>
</template>

<script setup lang="ts">
import { IonTextarea } from "@ionic/vue";
import { useField } from "vee-validate";

import { BaseTextareaProps } from "@/types/props";
import { TextareaBaseEmits } from "@/types/emits";

const props = withDefaults(defineProps<BaseTextareaProps>(), {
    rows: 4
})
const emit = defineEmits<TextareaBaseEmits>()

// Vee-Validate Composable
const {
    errors,
    handleChange,
    handleBlur,
    validate
} = useField(
    props.validateOption?.name ?? '',
    props.validateOption?.rules ?? '',
    {
        valueProp: props.modelValue,
        initialValue: JSON.parse(JSON.stringify(props.modelValue ?? '')),
        label: props.validateOption?.label ?? props.validateOption?.name,
        ...props.validateOption?.options ?? {}
    }
)

window.addEventListener('change-language', () => validate({ mode: 'force' }))
</script>

<style scoped>
.textarea-simple {
    border-radius: 8px;
    --placeholder-color: var(--ion-color-grey1);
    --padding-start: 10px;
    --highlight-color-focused: var(--ion-color-purple);
}
</style>